import { css } from 'lit'

export const style = css`
  :host {
    --wego-input-text-color: var(--hds-foreground-primary);
  }

  .wrapper .input-wrapper input {
    color: var(--wego-input-text-color);
  }

  :host(:focus) {
    outline: 0;
  }

  .action-slot {
    padding-right: 0.625rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.2rem;
  }

  ::slotted(*) {
    --hds-icon-color: var(--hds-foreground-secondary);
    cursor: pointer;
    z-index: 100;
  }
`
